import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import UnoButton from "../../utils/UnoButton";
import { MyTab, MyTabs } from '../../utils/MyTabs';
import DefaultScrollWithHeaderContent from '../../utils/DefaultScrollWithHeaderContent';
import AddFundGroupClientModal from '../../modals/AddFundGroupClientModal';

import { FundGroupsAPI } from '../../../API/fund_groups'

import { tabs, unoTheme } from '../../../assets/styles/unoTheme'

import allActions from "../../../actions";

import moment from 'moment'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    tabs: tabs,
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    inputSearch: {
        width: "300px",
        background: "white"
    },
    deleteIcon: {
        color: unoTheme.errorColor,
    },
}));

const TAB_GROUPS = 0;
const TAB_CLIENTS = 1;

export default function FundsGroupsScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();

    const rightContent = useSelector(state => state.rightContent)

    const [tabValue, setTabValue] = useState(TAB_GROUPS);

    const [fundsGroups, setFundsGroups] = useState([]);

    //Clientes liberados para predefinição de comparação atrelada a agrupamento
    const [fundGroupClients, setFundGroupClients] = useState([]);
    const [loadingClients, setLoadingClients] = useState(false);
    const [openAddClientModal, setOpenAddClientModal] = useState(false);
    const [savingClient, setSavingClient] = useState(false);

    async function doGetFundsGroups() {

        const response = await FundGroupsAPI.getFundGroups();
        if (response.success) {

            setFundsGroups(response.body.rows);

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao listar agrupamentos de fundos"
            }))

        }
    }

    async function doGetFundGroupClients() {

        setLoadingClients(true);

        const response = await FundGroupsAPI.getFundGroupClients();
        if (response.success) {

            setFundGroupClients(response.body.rows);

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao listar clientes liberados"
            }))

        }

        setLoadingClients(false);
    }

    async function doAddFundGroupClient(client) {

        setSavingClient(true);

        const response = await FundGroupsAPI.addFundGroupClient(client.id);

        setSavingClient(false);

        if (response.success) {

            setOpenAddClientModal(false);

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "success",
                message: "Cliente adicionado com sucesso"
            }))

            doGetFundGroupClients();

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao adicionar cliente"
            }))

        }
    }

    async function doDeleteFundGroupClient(clientId) {

        const response = await FundGroupsAPI.deleteFundGroupClient(clientId);
        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "success",
                message: "Cliente removido com sucesso"
            }))

            doGetFundGroupClients();

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao remover cliente"
            }))

        }
    }

    useEffect(() => {

        doGetFundsGroups();

        if ((rightContent && rightContent.action)) {

            dispatch(allActions.rightContentActions.setRightContent(null))

        }

    }, [rightContent]);

    useEffect(() => {

        doGetFundGroupClients();

    }, []);

    const [searchText, setSearchText] = useState("");

    const delayedChange = (text) => {
        setTimeout(() => {
            setSearchText(text)
        }, 800)
    }

    function changeSearch(e) {

        delayedChange(e.target.value.toUpperCase())
        clearTimeout(delayedChange);
    }

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>
                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, newValue) => setTabValue(newValue)}>
                        <MyTab label="Agrupamentos" value={TAB_GROUPS} />
                        <MyTab label="Clientes" value={TAB_CLIENTS} />
                    </MyTabs>
                </div>

                <div className={classes.rightHeader}>

                    <TextField id="standard-basic"
                        onChange={(event) => changeSearch(event)}
                        className={classes.inputSearch}
                        label="Buscar..."
                        variant="outlined"
                        size="small" />

                    {tabValue === TAB_GROUPS &&
                        <UnoButton
                            style={{ marginLeft: '16px' }}
                            variant="contained"
                            type='primary'
                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                path: 'newFundsGroup'
                            }))}
                            startIcon={<AddIcon />}>
                            {"NOVO AGRUPAMENTO"}
                        </UnoButton>
                    }

                    {tabValue === TAB_CLIENTS &&
                        <UnoButton
                            style={{ marginLeft: '16px' }}
                            variant="contained"
                            type='primary'
                            onClick={() => setOpenAddClientModal(true)}
                            startIcon={<AddIcon />}>
                            {"ADICIONAR CLIENTE"}
                        </UnoButton>
                    }
                </div>
            </div>

            {tabValue === TAB_GROUPS &&
                <DefaultScrollWithHeaderContent>
                    <MyTable
                        selectable="true"
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col width="60%" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Título</TableCell>
                                <TableCell align="center">Nº de artigos</TableCell>
                                <TableCell align="center">Data de cadastro</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                fundsGroups && fundsGroups.length ? fundsGroups.map((row) => (
                                    <React.Fragment key={row.id}>
                                        {
                                            searchText == "" || (
                                                row.title && row.title.toUpperCase().includes(searchText)) ?
                                                <TableRow onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                                    path: 'newFundsGroup',
                                                    update: true,
                                                    data: row
                                                }))}>
                                                    <TableCell align="left">{row.title}</TableCell>
                                                    <TableCell align="center">{row.articles_count}</TableCell>
                                                    <TableCell align="center">
                                                        {moment.utc(row.created_date).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                </TableRow> : null
                                        }
                                    </React.Fragment>
                                )) : null
                            }
                        </TableBody>
                    </MyTable>
                </DefaultScrollWithHeaderContent>
            }

            {tabValue === TAB_CLIENTS &&
                <DefaultScrollWithHeaderContent
                    innerLoad={loadingClients
                        ? { show: true, loadMessage: 'Carregando clientes...' }
                        : (fundGroupClients.length === 0
                            ? { show: true, emptyMessage: 'Nenhum cliente liberado' }
                            : null)}>
                    <MyTable
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col width="70%" />
                            <col width="20%" />
                            <col width="10%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Cliente</TableCell>
                                <TableCell align="center">Data de liberação</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                fundGroupClients.map((row) => (
                                    <React.Fragment key={'fund-group-client-' + row.id}>
                                        {
                                            searchText == "" || (
                                                row.label_name && row.label_name.toUpperCase().includes(searchText)) ?
                                                <TableRow>
                                                    <TableCell align="left">{row.label_name}</TableCell>
                                                    <TableCell align="center">
                                                        {moment.utc(row.created_date).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton
                                                            size={'small'}
                                                            onClick={() => doDeleteFundGroupClient(row.client_id)}>
                                                            <DeleteIcon className={classes.deleteIcon} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow> : null
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </TableBody>
                    </MyTable>
                </DefaultScrollWithHeaderContent>
            }

            <AddFundGroupClientModal
                open={openAddClientModal}
                enabledClientsIds={fundGroupClients.map(el => el.client_id)}
                saving={savingClient}
                handleAdd={(client) => doAddFundGroupClient(client)}
                handleClose={() => setOpenAddClientModal(false)}
            />

        </div>
    );
}
